import axios from 'axios';
import alt from './../alt/alt';

class DataActions {

  constructor() {
    const appUrl = 'https://regis.digital/';

    this.pagesEndPoint = `${appUrl}/wp-json/wp/v2/pages`;
    this.workEndPoint = `${appUrl}/wp-json/wp/v2/work`;
  }

  api(endPoint) {
    return new Promise((resolve, reject) => {
      axios.get(endPoint).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getPages(cb) {
    return (dispatch) => {
      dispatch();
      this.api(this.pagesEndPoint).then((response)=> {
        this.getWork(response, cb)
      });
    }
  }

  getWork(pages, cb) {
    return (dispatch) => {
      dispatch();
      this.api(this.workEndPoint).then((response)=> {
        const work 	    = response;
        const payload 	= { pages, work };

        this.getSuccess(payload);
        cb(payload);
      });
    }
  }

  getSuccess(payload) {
    return payload;
  }
}

export default alt.createActions(DataActions);



// WEBPACK FOOTER //
// ./src/actions/DataActions.js